import useMutation from 'use-mutation'
import { post } from './api'
import { Inquiry } from './types'

const createInquiry = ({ inquiry }: { inquiry: Inquiry }) =>
  post<Inquiry>('/inquiries', inquiry)

export const useCreateInquiry = () => useMutation(createInquiry)
